import apiClient from './apiClient'


const getProjectsWithEventsXlsx = (tenant, seasonId) => {
  return apiClient.get(`/${tenant}/Excel/${seasonId}`, { responseType: 'blob' })
}


export default {
  getProjectsWithEventsXlsx
}
